import { z } from 'zod'
import { Model } from './architecture'

export const ColorValidation = z.object({
  value: z.string().regex(/^#[0-9a-fA-F]{6}$/, {
    message: '[Color] Invalid color format. Must be a 7-character hex code (e.g., #RRGGBB).',
  }),
})

export class Color extends Model {
  static create({ value }: z.infer<typeof ColorValidation>) {
    ColorValidation.parse({ value })
    return new Color(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
